// Signature pinned choreography for the home "private dinner" section
// (guidelines §6). Desktop: the section pins while the video settles and the
// copy sequences in on scrub. Mobile: gentle one-shot fade-ups, no pinning.
import { gsap, prefersReduced } from '../gsap-init.js';

const scope = document.querySelector('.private-dinner');

if (scope && !prefersReduced) {
  const video = scope.querySelector('.private-dinner__video');
  const title = scope.querySelector('.private-dinner__title');
  const paras = gsap.utils.toArray(scope.querySelectorAll('.private-dinner__content p'));
  const cta = scope.querySelector('.private-dinner__cta');

  const mm = gsap.matchMedia(scope); // scoped = auto-cleanup on revert

  mm.add('(min-width: 768px)', () => {
    gsap.set([title, ...paras, cta], { autoAlpha: 0, y: 32 });
    if (video) gsap.set(video, { scale: 1.18, transformOrigin: '50% 50%' });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scope,
        start: 'top top',
        end: '+=130%',
        pin: true,
        scrub: 1,
        anticipatePin: 1,
      },
    });

    // Copy starts revealing immediately on pin so nothing feels late.
    if (video) tl.to(video, { scale: 1, ease: 'power2.out', duration: 3 }, 0);
    tl.to(title, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 1.6 }, 0);
    tl.to(paras, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 1.8, stagger: 0.6 }, '>-0.9');
    tl.to(cta, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 1.4 }, '>-0.4');
    tl.to({}, { duration: 1 }); // hold beat before unpinning
  });

  mm.add('(max-width: 767px)', () => {
    // Explicit set + to(autoAlpha: 1): the no-FOUC CSS already holds these at
    // opacity 0, so gsap.from() would tween 0 → 0 and never show them.
    [title, ...paras, cta].filter(Boolean).forEach((el) => {
      gsap.set(el, { autoAlpha: 0, y: 24 });
      gsap.to(el, {
        autoAlpha: 1,
        y: 0,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      });
    });
  });
}
